import { useState } from 'react';
import Financial from '../../components/Financial/Financial';
import Reload from '../../components/reload/reload'
import Page from '../../components/Page/Page';
import Headers from '../../components/Headers/Headers';

const MercadoFinanceiro = () => {
  const [loading, setLoading] = useState(true);

  return (
    <Page title={"Mercado Financeiro"}>
      <Headers page={"Mercado Financeiro"} />
      {loading && <Reload />}
      <Financial setLoading={setLoading} />
    </Page>
  )
}
export default MercadoFinanceiro;
